import { HTTPStatusCodes } from '@omnipresentgroup/constants';
import type { BillingEntity } from '@omnipresentgroup/types';
import { HttpResponse, http } from 'msw';

import { API_PATH } from './constants';
import { DEFAULT_BILLING_ENTITIES } from './fixtures';

export const payrollsHandlers = [
  http.get(`*/${API_PATH}?companyId=*`, () =>
    HttpResponse.json<BillingEntity[]>(DEFAULT_BILLING_ENTITIES, {
      status: HTTPStatusCodes.OK,
    }),
  ),
];
